import React from 'react'

import PageHeader from '@/components/misc/PageHeader'
import { ScrollableTab } from '@/components/misc/ScrollableTabs'
import { ROUTES } from '@/lib/routes'

const RqCertifiedPageHeader: React.FC = () => {
  const tabs: ScrollableTab[] = [
    {
      label: 'Application',
      to: ROUTES.rqCertifiedApplicationStatus(),
    },
    {
      label: 'Application Process',
      to: ROUTES.rqCertifiedApplicationProcess(),
    },
    {
      label: 'Glossary',
      to: ROUTES.rqCertifiedGlossary(),
    },
    {
      label: 'PDF Guides',
      to: ROUTES.rqCertifiedPdfGuides(),
    },
  ]

  return <PageHeader title="RQ Certified" tabs={tabs} />
}

export default RqCertifiedPageHeader
